import CryptoJS, { SHA512 } from "crypto-js";

export function generateSHA512HashAndEncryptInES6(data) {
  const hash = SHA512(data);
  const hashResult = hash.toString();
  return encrypt(hashResult);
}

// Encryption function
export const encrypt = (plainText) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
  const encryptedData = CryptoJS.AES.encrypt(plainText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encryptedData.toString();
};

// Decryption function
export const decrypt = (encryptedText) => {
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_KEY);
  const decryptedData = CryptoJS.AES.decrypt(encryptedText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decryptedData.toString(CryptoJS.enc.Utf8);
};

// Encryption function
export const encryptMarks = (plainText, encKey) => {
  const key = CryptoJS.enc.Utf8.parse(encKey);
  const encryptedData = CryptoJS.AES.encrypt(plainText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encryptedData.toString();
};

// Decryption function
export const decryptMarks = (encryptedText, encKey) => {
  const key = CryptoJS.enc.Utf8.parse(encKey);
  const decryptedData = CryptoJS.AES.decrypt(encryptedText, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return decryptedData.toString(CryptoJS.enc.Utf8);
};

export function generateES6Hash(data) {
  const encryptedText = CryptoJS.AES.encrypt(
    data,
    process.env.REACT_APP_KEY,
  ).toString();
  return encryptedText;
}

export function decryptES6Hash(encryptedText) {
  const decryptedData = CryptoJS.AES.decrypt(
    encryptedText,
    process.env.REACT_APP_KEY,
  ).toString(CryptoJS.enc.Utf8);
  return decryptedData;
}
